<style lang="less" rel="stylesheet/less" scope>
.permission {
  .el-tree {
    border: 1px solid #d1dbe5;
  }
}
</style>
<template>
  <div class="permission" @mouseover="overShow" @mouseout="outHide">
    <el-tree
      :data="optionData"
      :check-strictly="true"
      @check-change="nodeClick"
      node-key="id"
      ref="tree"
      :show-checkbox="isCheckBox"
      accordion
      :default-checked-keys="checkedKeys"
      highlight-current
      :props="defaultProps">
    </el-tree>
  </div>
</template>
<script type='text/ecmascript-6'>
  import { getRoleTree } from '@/api/userManage'
  import { getPathById } from '@/api/tree'
  export default {
    name: 'LySetPermission',
    props: {
      options: Object, // 请求后数据 res.data
      isCheckBox: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      checkedKeys: [], // 选中的id  Arrary
      activeNames: ['1','2','3','4'],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isOpen: false
    }),
    computed: {
      optionData() {
        return this.options && this.options.children ? this.options.children : [];
      },
      dabble() {
        return this.isOpen;
      }
    },
    methods: {
      overShow() {
        this.isOpen = true;
      },
      outHide() {
        this.isOpen = false;
      },
      nodeClick(node, t, f) {
        if(this.dabble) {
          this.$refs.tree.setChecked(node.id, t, true);
        }
      },
      setCheckedKeys(node) {
        if (!node || !node.children) { return; }
        if (node.checked) {
          this.checkedKeys.push(node.id);
        }
        node.children.forEach((item, index) => {
          this.setCheckedKeys(item);
        });
      },
      getCheckedKeys() {
        let nodeKeys = this.$refs.tree.getCheckedKeys();
        let keys = [];
        for (let key of nodeKeys) {
          getPathById(key, this.options, (res) => {
            keys.push.apply(keys,res);
          });
        }
        let checkedKeys = Array.from(new Set(keys)).slice(1);
        if (checkedKeys.includes('root')) {
          return checkedKeys.slice(1);
        } else {
          return checkedKeys;
        }
      },
    },
    watch: {
      options: {
        handler: function (val) {
          this.checkedKeys = [];
          this.setCheckedKeys(val);
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/set-permission/index.vue